export default "__VITE_ASSET__D43DCmKF__"